export default [
    {
        id: 1,
        name_ca: 'Règim general',
        name_en: 'General regime',
        name_es: 'Régimen general'
    },
    {
        id: 2,
        name_ca: 'Règim especial',
        name_en: 'Special regime',
        name_es: 'Régimen especial'
    },
    {
        id: 3,
        name_ca: 'Preu concertat',
        name_en: 'Agreed price',
        name_es: 'Precio concertado'
    }
]



// WEBPACK FOOTER //
// ./src/options/protection_regimes.js